export default __webpack_public_path__ + "static/media/hht1_home_img_EP7.b4e0ecd8.png";